module.exports = __webpack_public_path__ + "img/marketFriend.4ea51e93.svg";